'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import composeClasses from '@mui/utils/composeClasses';
import { styled } from "../zero-styled/index.js";
import memoTheme from "../utils/memoTheme.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import AddIcon from "../internal/svg-icons/Add.js";
import speedDialIconClasses, { getSpeedDialIconUtilityClass } from "./speedDialIconClasses.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, open = ownerState.open, openIcon = ownerState.openIcon;
    var slots = {
        root: [
            'root'
        ],
        icon: [
            'icon',
            open && 'iconOpen',
            openIcon && open && 'iconWithOpenIconOpen'
        ],
        openIcon: [
            'openIcon',
            open && 'openIconOpen'
        ]
    };
    return composeClasses(slots, getSpeedDialIconUtilityClass, classes);
};
var SpeedDialIconRoot = styled('span', {
    name: 'MuiSpeedDialIcon',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            _define_property({}, "& .".concat(speedDialIconClasses.icon), styles.icon),
            _define_property({}, "& .".concat(speedDialIconClasses.icon), ownerState.open && styles.iconOpen),
            _define_property({}, "& .".concat(speedDialIconClasses.icon), ownerState.open && ownerState.openIcon && styles.iconWithOpenIconOpen),
            _define_property({}, "& .".concat(speedDialIconClasses.openIcon), styles.openIcon),
            _define_property({}, "& .".concat(speedDialIconClasses.openIcon), ownerState.open && styles.openIconOpen),
            styles.root
        ];
    }
})(memoTheme(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        height: 24
    }, _define_property(_obj, "& .".concat(speedDialIconClasses.icon), {
        transition: theme.transitions.create([
            'transform',
            'opacity'
        ], {
            duration: theme.transitions.duration.short
        })
    }), _define_property(_obj, "& .".concat(speedDialIconClasses.openIcon), {
        position: 'absolute',
        transition: theme.transitions.create([
            'transform',
            'opacity'
        ], {
            duration: theme.transitions.duration.short
        }),
        opacity: 0,
        transform: 'rotate(-45deg)'
    }), _define_property(_obj, "variants", [
        {
            props: function(param) {
                var ownerState = param.ownerState;
                return ownerState.open;
            },
            style: _define_property({}, "& .".concat(speedDialIconClasses.icon), {
                transform: 'rotate(45deg)'
            })
        },
        {
            props: function(param) {
                var ownerState = param.ownerState;
                return ownerState.open && ownerState.openIcon;
            },
            style: _define_property({}, "& .".concat(speedDialIconClasses.icon), {
                opacity: 0
            })
        },
        {
            props: function(param) {
                var ownerState = param.ownerState;
                return ownerState.open;
            },
            style: _define_property({}, "& .".concat(speedDialIconClasses.openIcon), {
                transform: 'rotate(0deg)',
                opacity: 1
            })
        }
    ]), _obj;
}));
var SpeedDialIcon = /*#__PURE__*/ React.forwardRef(function SpeedDialIcon(inProps, ref) {
    var props = useDefaultProps({
        props: inProps,
        name: 'MuiSpeedDialIcon'
    });
    var className = props.className, iconProp = props.icon, open = props.open, openIconProp = props.openIcon, other = _object_without_properties(props, [
        "className",
        "icon",
        "open",
        "openIcon"
    ]);
    var ownerState = props;
    var classes = useUtilityClasses(ownerState);
    function formatIcon(icon, newClassName) {
        if (/*#__PURE__*/ React.isValidElement(icon)) {
            return /*#__PURE__*/ React.cloneElement(icon, {
                className: newClassName
            });
        }
        return icon;
    }
    return /*#__PURE__*/ _jsxs(SpeedDialIconRoot, _object_spread_props(_object_spread({
        className: clsx(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other), {
        children: [
            openIconProp ? formatIcon(openIconProp, classes.openIcon) : null,
            iconProp ? formatIcon(iconProp, classes.icon) : /*#__PURE__*/ _jsx(AddIcon, {
                className: classes.icon
            })
        ]
    }));
});
process.env.NODE_ENV !== "production" ? SpeedDialIcon.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Override or extend the styles applied to the component.
   */ classes: PropTypes.object,
    /**
   * @ignore
   */ className: PropTypes.string,
    /**
   * The icon to display.
   */ icon: PropTypes.node,
    /**
   * @ignore
   * If `true`, the component is shown.
   */ open: PropTypes.bool,
    /**
   * The icon to display in the SpeedDial Floating Action Button when the SpeedDial is open.
   */ openIcon: PropTypes.node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object,
            PropTypes.bool
        ])),
        PropTypes.func,
        PropTypes.object
    ])
} : void 0;
SpeedDialIcon.muiName = 'SpeedDialIcon';
export default SpeedDialIcon;
